import { setCookie, Cookie } from '@lib/utils/cookies'

export const setPardotAssociatedCookies = (email: string, url: string) => {
  setCookie(Cookie.pardotAssociatedEmail, email, 60)
  setCookie(Cookie.pardotAssociatedUrl, url, 60)
}
